















import StatsCard from '@/components/StatsCard.vue';
import Graph from '@/components/Graph.vue';
import VersionsTable from '@/components/VersionsTable.vue';
import UsersTable from '@/components/UsersTable.vue';

export default {
  name: 'home',
  components: {
    StatsCard,
    Graph,
    VersionsTable,
    UsersTable,
  },
};
